export enum ShipmentDeliveryTotalFieldTypes {
    quantity = "quantity",
    price = "price",
    kg = "kg",
    m3 = "m3",
    pallet = "pallet",
    netKg = "netKg",
    boxes = "boxes",
    bags = "bags",
    sacks = "sacks",
    litres = "litres"
};
